<div class="dsb-row">
  <div class="dsb-col-6">
    <div>
      <div class="tab-list" role="tablist" style="margin-bottom: 1rem;" aria-orientation="horizontal">
        <ds-tab-primary [attr.tab-text]="'Dashboard.OrdiniTabStr' | translate" [attr.tab-orientation]="'horizontal'"
          [attr.tab-aria-label]="
            ('Dashboard.OrdiniTabStr' | translate) + ' - Tab 1 di 3'
          " [attr.tab-selected]="selectedTab === 1" tab-id="tabOrdini" tab-aria-controls-id="panelOrdini"
          (onTabClick)="onClickOrdini()"></ds-tab-primary>
        <ds-tab-primary [attr.tab-text]="'Dashboard.SvincoliTabStr' | translate" [attr.tab-orientation]="'horizontal'"
          [attr.tab-aria-label]="
            ('Dashboard.SvincoliTabStr' | translate) + ' - Tab 2 di 3'
          " [attr.tab-selected]="selectedTab === 2" tab-id="tabSvincoli" tab-aria-controls-id="panelSvincoli"
          (onTabClick)="onClickSvincoli()"></ds-tab-primary>
        <ds-tab-primary [attr.tab-text]="'Dashboard.NonConformitaTabStr' | translate"
          [attr.tab-orientation]="'horizontal'" [attr.tab-aria-label]="
            ('Dashboard.NonConformitaTabStr' | translate) + ' - Tab 3 di 3'
          " [attr.tab-selected]="selectedTab === 3" tab-id="tabNonConformita" tab-aria-controls-id="panelNonConformita"
          (onTabClick)="onClickNonConformita()"></ds-tab-primary>

        @switch (selectedTab) {
        @case (1) {
        <ds-button [attr.button-ui-variant]="'tertiary'" [attr.button-size]="'small'"
          [attr.button-icon]="'icon-arrow-right'" [attr.button-label]="'Dashboard.VaiAgliOrdiniStr' | translate"
          [attr.button-aria-label]="'Dashboard.VaiAgliOrdiniStr' | translate" (onClickEvent)="vaiAgliOrdini()"
          style="margin-left: auto"></ds-button>
        }
        @case (2) {
        <ds-button [attr.button-ui-variant]="'tertiary'" [attr.button-size]="'small'"
          [attr.button-icon]="'icon-arrow-right'" [attr.button-label]="'Dashboard.VaiAgliSvincoliStr' | translate"
          [attr.button-aria-label]="'Dashboard.VaiAgliSvincoliStr' | translate" (onClickEvent)="vaiAgliSvincoli()"
          style="margin-left: auto"></ds-button>
        }
        @case (3) {
        <ds-button [attr.button-ui-variant]="'tertiary'" [attr.button-size]="'small'"
          [attr.button-icon]="'icon-arrow-right'" [attr.button-label]="'Dashboard.VaiAlleNonConformitaStr' | translate"
          [attr.button-aria-label]="'Dashboard.VaiAlleNonConformitaStr' | translate"
          (onClickEvent)="vaiAlleNonConformita()" style="margin-left: auto"></ds-button>
        }
        }
      </div>

      <div id="panelOrdini" role="tabpanel" aria-labelledby="tabOrdini" *ngIf="selectedTab === 1">
        <app-dashboard-ordini [isTeamView]="isTeamView"></app-dashboard-ordini>
      </div>

      <div id="panelSvincoli" role="tabpanel" aria-labelledby="tabSvincoli" *ngIf="selectedTab === 2">
        <app-dashboard-svincoli [isTeamView]="isTeamView"></app-dashboard-svincoli>
      </div>

      <div id="panelNonConformita" role="tabpanel" aria-labelledby="tabNonConformita" *ngIf="selectedTab === 3">
        <app-dashboard-non-conformita [isTeamView]="isTeamView"></app-dashboard-non-conformita>
      </div>
    </div>
  </div>
  <div class="dsb-col-6">
    <div>
      <app-dashboard-collaudi [isTeamView]="isTeamView"></app-dashboard-collaudi>
    </div>
  </div>
</div>